import { combineReducers } from 'redux';
import identities from './identities';
import { reducer as notificationsReducer } from 'reapop';
import terms from './terms';
import configurations from './configurations';
import subscriptions from './subscriptions';
import termSelectReducer from './termselect';
import shippingPrice from './shippingprice';
import { reducer as formReducer } from 'redux-form';
import cache from './cache/cache';
import home from './home';
// import snackbar from "./snackbar";

export default combineReducers({
  identities,
  terms,
  configurations,
  subscriptions,
  notifications: notificationsReducer(),
  termSelectReducer,
  shippingPrice,
  cache,
  home,
  form: formReducer
});
